import React from "react";
import { Route, Routes } from "react-router-dom";
import { useLoginStore } from "../modules/LoginModule/store";

const Login = React.lazy(() => import("../pages/Login"));
const Users = React.lazy(() => import("../pages/Users"));
const UserDetails = React.lazy(() => import("../pages/UserDetails"));
const OtpCooldowns = React.lazy(() => import("../pages/OtpCooldowns"));
// const Home = React.lazy(() => import("../pages/Home")); // todo: проверить, нужна ли эта страница на данный момент
const SosOrders = React.lazy(() => import("../pages/Orders/SosOrders"));
const SosOrderDetails = React.lazy(
  () => import("../pages/Orders/SosOrderDetails"),
);

const NoAuth = React.lazy(() => import("../pages/System/NoAuth"));
const AccessDenied = React.lazy(() => import("../pages/System/AccessDenied"));
const PageNotFound = React.lazy(() => import("../pages/System/PageNotFound"));
const ProtectedRoute = React.lazy(() => import("./ProtectedRoute"));

export const RouteList = () => {
  const isAuth = useLoginStore((state) => !!state.accessToken);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <SosOrders />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <UserDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/otp-cooldowns"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <OtpCooldowns />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders/sos"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <SosOrders />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders/sos/:id"
        element={
          <ProtectedRoute isAuth={isAuth}>
            <SosOrderDetails />
          </ProtectedRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/no-auth" element={<NoAuth />} />
      <Route path="/access-denied" element={<AccessDenied />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
